<template>
  <div class="personalCenter">
    <div class="pom-bar">
      监测中心<span class="gray-line">/</span><span :class="isfir?'active-bar':''" @click="choseurl()" style="cursor:pointer;">能源监测</span>
      <span class="gray-line" v-show="!isfir">/</span><span v-show="!isfir" :class="isfir?'':'active-bar'">报表生成</span>
      <span class="report-btn" @click="getReport()" v-show="isfir">生成报表</span>
      <span class="report-btn" @click="printReport()" v-show="!isfir">导出报表</span>
    </div>
    <div class="fir-blank" v-show="isfir">
      <div class="power-sum">
        <div class="item-title">
          用电统计
        </div>
        <div class="data-card">
          <div class="card-item">
            <div class="card-left">
              <div>
                今日用电(kwh)
              </div>
              <div class="blue-font">
                {{ powerdata.todayEnergy }}
                <span class="red-font" v-if="Number(powerdata.yesterdaySamePeriodRingRatio) > 0"><img class="jiantou" src="../../assets/station/up.png" alt=""> {{ powerdata.yesterdaySamePeriodRingRatio}} %</span>
                <span class="green-font" v-else ><img class="jiantou" src="../../assets/station/down.png" alt="">   {{ powerdata.yesterdaySamePeriodRingRatio}} %</span>
              </div>
            </div>
            <div class="card-left">
              <div>
                昨日用电(kwh)
              </div>

              <div class="gray-font">
                {{ powerdata.yesterdaySamePeriodEnergy }}
              </div>
            </div>
          </div>
          <div class="card-item">
            <div class="card-left">
              <div>
                本周用电(kwh)
              </div>
              <div class="blue-font">
                {{ powerdata.thisWeekEnergy }}
                <span class="red-font" v-if="Number(powerdata.oneBeforeWeekSamePeriodRingRatio) > 0"><img class="jiantou" src="../../assets/station/up.png" alt=""> {{ powerdata.oneBeforeWeekSamePeriodRingRatio}} %</span>
                <span class="green-font" v-else ><img class="jiantou" src="../../assets/station/down.png" alt="">   {{ powerdata.oneBeforeWeekSamePeriodRingRatio}} %</span>
              </div>
            </div>
            <div class="card-left">
              <div>
                上周用电(kwh)
              </div>
              <div class="gray-font">
                {{ powerdata.oneBeforeWeekSamePeriodEnergy }}
              </div>
            </div>
          </div>
          <div class="card-item">
            <div class="card-left">
              <div>
                本月用电(kwh)
              </div>
              <div class="blue-font">
                {{ powerdata.thisMonthEnergy }}
                <span class="red-font" v-if="Number(powerdata.oneBeforeMonthSamePeriodRingRatio) > 0"><img class="jiantou" src="../../assets/station/up.png" alt=""> {{ powerdata.oneBeforeMonthSamePeriodRingRatio}} %</span>
                <span class="green-font" v-else ><img class="jiantou" src="../../assets/station/down.png" alt="">   {{ powerdata.oneBeforeMonthSamePeriodRingRatio}} %</span>
              </div>
            </div>
            <div class="card-left">
              <div>
                上月用电(kwh)
              </div>
              <div class="gray-font">
                {{ powerdata.oneBeforeMonthSamePeriodEnergy }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="power-sum">
        <div class="item-title">
          用电趋势
        </div>
        <div class="item-group" style="margin-top: 36px;margin-left: 40px;">
            <span class="item-btn " :class="isrisk=='day'?'active-btn':''" @click="changerisk('day')">
              日
              <div class="blue-blank">

              </div>
            </span>
          <span class="item-btn " :class="isrisk=='month'?'active-btn':''" @click="changerisk('month')">
              月
              <div class="blue-blank">

              </div>
            </span>
          <span class="item-btn " :class="isrisk=='year'?'active-btn':''" @click="changerisk('year')">
              年
              <div class="blue-blank">

              </div>
            </span>
          <div class="gray-line">

          </div>
        </div>
        <div class="time-select">
          <el-date-picker
            v-if="isrisk=='year'"
            v-model="year"
            value-format="yyyy"
            size="large"
            type="year"
          >
          </el-date-picker>
          <el-date-picker
            v-model="month"
            v-if="isrisk=='month'"
            size="large"
            value-format="yyyy-MM"
            type="month"
          >
          </el-date-picker>
          <el-date-picker
            v-model="time"
            size="large"
            v-if="isrisk=='day'"
            value-format="yyyy-MM-dd"
            type="date"
          >
          </el-date-picker>
          <div class="btn-item" @click="searchdata()">
            查询
          </div>
        </div>
        <div class="cav-chart" id="trendCav2">

        </div>
      </div>
      <div class="power-sum">
        <div class="item-title">
          用电占比
        </div>
        <div class="cav-select">
          <div class="item-group" >
            <span class="item-btn " :class="isrisk2=='day'?'active-btn':''" @click="changerisk2('day')">
              周
              <div class="blue-blank">

              </div>
            </span>
            <span class="item-btn " :class="isrisk2=='month'?'active-btn':''" @click="changerisk2('month')">
              月
              <div class="blue-blank">

              </div>
            </span>

            <div class="gray-line">

            </div>
          </div>
        </div>
        <div class="nodata-table" v-if="nodata">
          暂无数据
        </div>
        <div class="all-cav" v-show="!nodata">
          <div class="cir-cav" id="precav">

          </div>
          <div class="cir-detail">
            <div class="detiail-item">
              <div class="station-item">
                <div class="flex-item" v-for="(item , index) in preList">
                  <div class="cir-fang" :style="{ background: colorList[index]}">

                  </div>
                  <div class="item-name">
                    {{ item.monitorSiteName }}
                  </div>
                  <div class="item-percent">
                    {{ item.proportion }}%
                  </div>
                  <div class="item-num">
                    {{ item.monitorSiteDegree }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-blank" v-show="!isfir">
      <div class="power-sum">
        <div class="item-title">
          能耗报表
        </div>

      </div>
    </div>
    <el-dialog
      title="能源报表生成"
      :visible.sync="showList"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="data-chose">
        <div>
          <div style="margin-bottom: 16px;">
            生成方式选择：
          </div>
          <span>
          <el-radio v-model="datatype" label="1">按监测点导出</el-radio>
          <el-radio v-model="datatype" label="2">按单位导出</el-radio>
        </span>
        </div>
        <div>
          <div style="margin-bottom: 16px;margin-top: 10px;">
            时间间隔选择：
          </div>
          <span>
          <el-radio v-model="timetype" label="1">按日导出</el-radio>
          <el-radio v-model="timetype" label="2">按月导出</el-radio>
        </span>
        </div>
        <div class="date-select">
          数据时段：
          <span v-if="timetype=='1'">
             <el-date-picker
               v-model="datastart"
               value-format="yyyy-MM-dd"
               size="large"
               style="width: 200px;"
               type="date"
               placeholder="开始时间"
               :picker-options="pickerOptions0"
               @input="change($event)"
             ></el-date-picker>
            -
            <el-date-picker
              style="width: 200px"
              size="large"
              v-model="dataend"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束时间"
              :picker-options="pickerOptions1"
              @input="change($event)"
            ></el-date-picker>
        </span>
          <span v-else-if="timetype=='2'">
             <el-date-picker
               v-model="monthstart"
               value-format="yyyy-MM"
               size="large"
               style="width: 200px;"
               type="month"
               placeholder="开始时间"
             ></el-date-picker>
            -
            <el-date-picker
              style="width: 200px"
              size="large"
              v-model="monthend"
              value-format="yyyy-MM"
              type="month"
              placeholder="结束时间"
            ></el-date-picker>
        </span>
        </div>
        <div class="statin-btn">
          <div class="btn-item" @click="uploaddata()">
            确认
          </div>
          <div class="btn-cancel"  @click="showList=false">
            取消
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import qs from "qs";
import axios from "axios";

export default {
  name: "personalCenterPage",
  data() {
    return {
      powerdata:{
        oneBeforeMonthSamePeriodDeptEnergy: null,
        oneBeforeMonthSamePeriodDeptRingRatio:null,
        oneBeforeWeekSamePeriodDeptEnergy: null,
        oneBeforeWeekSamePeriodDeptRingRatio: null,
        thisMonthDeptEnergy: null,
        thisWeekDeptEnergy:null,
        todayDeptEnergy: null,
        yesterdaySamePeriodDeptEnergy:null,
        yesterdaySamePeriodDeptRingRatio: null,
      },
      pickerOptions0: {
        disabledDate: time => {
          const day = 30 * 24 * 3600 * 1000;
          if (this.dataend != "") {
            return (
              time.getTime() < new Date(this.dataend).getTime() - day ||
              time.getTime() > new Date(this.dataend).getTime()
            );
          } else {
            return time.getTime();
          }
        }
      },
      pickerOptions1: {
        disabledDate: time => {
          const day = 30 * 24 * 3600 * 1000;
          if (this.datastart != "") {
            return (
              time.getTime() > new Date(this.datastart).getTime() + day ||
              time.getTime() < new Date(this.datastart).getTime()
            );
          } else {
            return time.getTime();
          }
        }
      },

    isrisk:"day",
      isrisk2:"day",
      time:"",
      nodata:false,
      timetype:"1",
      datatype:"1",
      datastart:"",
      dataend:"",
      monthstart:"",
      monthend:"",
      month:"",
      showList:false,
      isfir:true,
      year:"2023",
      preList:[],
      colorList:['#FFAE4A','#19AF23','#205FEB','#D61E1E','#08979C'
        ,'#722ED1','#FA541C','#35B3D2','#EB35D3','#A75B43','rgba(50, 100, 20, 1)'],
      allEleList:[{
        "name":"1",
        "value":"2",
        "precent":"3",
      },{
        "name":"1",
        "value":"2",
        "precent":"3",
      }],
    };
  },
  methods: {
    getpowdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/energy/deptEnergyTotal"

      param.data={}
      Axios.ajax(param).then((res)=>{


        if(res.resultCode=='0'){
          this.powerdata=res.data

          for(let key in this.powerdata){
            if(Number(this.powerdata[key]) > 10000){
              this.powerdata[key]=(this.powerdata[key] / 10000).toFixed(2) +'万'
            }
          }
        }else{

        }

      })
    },
    printReport(){

    },
    change(val) {
      this.$emit('input', val)
    },
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date

      var yesnow = new Date();
      yesnow.setTime(yesnow.getTime() - 30 * 24 * 60 * 60 * 1000);
      var yesyear = yesnow.getFullYear(); //得到年份
      var yesmonth = yesnow.getMonth(); //得到月份
      var yesdate = yesnow.getDate(); //得到日期

      var yeshour = yesnow.getHours(); //得到小时
      var yesminu = yesnow.getMinutes(); //得到分钟
      var yessec = yesnow.getSeconds(); //得到秒
      var yesMS = yesnow.getMilliseconds(); //获取毫秒
      yesmonth = yesmonth + 1;
      if (yesmonth < 10) yesmonth = "0" + yesmonth;
      if (yesdate < 10) yesdate = "0" + yesdate;
      if (yeshour < 10) yeshour = "0" + yeshour;
      if (yesminu < 10) yesminu = "0" + yesminu;
      if (yessec < 10) yessec = "0" + yessec;
      if (yesMS < 100) yesMS = "0" + yesMS;
      var yestime = "";
      yestime =
        yesyear +
        "-" +
        yesmonth +
        "-" +
        yesdate

      this.year = year;
      this.month = year + "-" + month;
      this.time = time;

      this.datastart = time;
      this.dataend = time;
      this.monthstart= yesyear + "-" + yesmonth
      this.monthend= year + "-" + month
    },
    getReport(){
      this.showList=true
    },
    changerisk(data){

      this.isrisk=data
      if(data=='year'){
        let now = new Date();
        this.year= "2023"
      }
      this.searchdata()
    },
    changerisk2(data){

      this.isrisk2=data

      this.getchartdata()
    },
    searchdata(){
      let that = this;
      let param = {};
      let date=""
      let type=""
      if(this.isrisk=='day'){
        date=this.time
        param.url="/energy/deptHourEnergyTrend";
        param.data={
          localDate:date
        }
      }else if(this.isrisk=='month'){
        date=this.month
        param.url="/energy/deptDayEnergyTrend";
        param.data={
          yearMonth:date
        }
      }else if(this.isrisk=='year'){
        date=this.year
        param.url="/energy/deptMonthEnergyTrend";
        param.data={
          year:date
        }
      }
      param.method="post";


      Axios.ajax(param).then((res)=>{

        if(res.data){
          this.getchart2(res.data)
        }

      })
    },
    getchart2(data){

      let xdata=[]
      let ydata=[]
      let ydata2=[]
      let productCount=[]
      let productYield=[]
      for(let i=0;i<data.length;i++){
        xdata.push(data[i].dataTime)
        ydata.push(data[i].energy)
        ydata2.push(data[i].lastPeriodEnergy)
        // productCount.push(data[i].productCount)
        // productYield.push(data[i].productYield)
      }
      let myChart =this.$echarts.init(document.getElementById('trendCav2'));
      let option = {
        tooltip: {
          trigger: 'axis',

        },
        grid: {
          right: '6%',

          left: '6%',
          top: '40px',
          containLabel: true
        },

        xAxis: [

          {
            type: 'category',
            data:xdata,

            axisLine: {
              lineStyle: {
                color: '#0B4CA9'
              }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#000",
                fontSize: 12,
              },
              // interval:0,
              //rotate:30
            },
          }],
        yAxis: [{
          type: 'value',

          nameTextStyle: {
            color: '#000'
          },
          position: 'left',
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          splitLine: {
            show:false,
            lineStyle: {
              color: "#0B4CA9",
            }

          },
          axisLabel: {
            color: '#000',
            fontSize: 12,
          }
        },
          //   {
          //   type: 'value',
          //
          //   nameTextStyle: {
          //     color: '#000'
          //   },
          //   position: 'right',
          //   axisLine: {
          //     lineStyle: {
          //       color: '#0B4CA9'
          //     }
          //   },
          //   splitLine: {
          //     show:false,
          //     lineStyle: {
          //       color: "#0B4CA9",
          //     }
          //
          //   },
          //   axisLabel: {
          //     color: '#000',
          //     fontSize: 12,
          //   }
          // },
        ],
        series: [
          {
            name: "能耗",
            type: "line",

            smooth: true, //平滑曲线显示
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 4, //标记的大小
            itemStyle: {
              //折线拐点标志的样式
              color: "#41d9ff"
            },
            lineStyle: {
              color: "#41d9ff"
            },
            data:ydata
          },
          {
            name: "同期能耗",
            type: "line",

            smooth: true, //平滑曲线显示
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 4, //标记的大小
            itemStyle: {
              //折线拐点标志的样式
              color: "rgba(47, 194, 91, 1)"
            },
            lineStyle: {
              color: "rgba(47, 194, 91, 1)"
            },

            data:ydata2
          },
          // {
          //   name: "产量",
          //   type: "line",
          //   yAxisIndex:1,
          //   smooth: true, //平滑曲线显示
          //   showAllSymbol: true, //显示所有图形。
          //   symbol: "circle", //标记的图形为实心圆
          //   symbolSize: 4, //标记的大小
          //   itemStyle: {
          //     //折线拐点标志的样式
          //     color: "rgba(250, 204, 20, 1)"
          //   },
          //   lineStyle: {
          //     color: "rgba(250, 204, 20, 1)"
          //   },
          //
          //   data:productCount
          // },

        ]
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    getchartdata(){
      let that = this;
      let param = {};
      let data=this.isrisk2=="day"?7:30
      param.url="/energy/monitorEnergyProportion";
      param.data=qs.stringify({
        day:data
      })
      param.method="post";


      Axios.ajax(param).then((res)=>{

        if(res.data){
          if(res.data.monitorSiteProportions.length==0){
            this.nodata=true
          }else{
            this.nodata=false
            this.preList=res.data.monitorSiteProportions
            this.setchart(res.data.monitorSiteProportions)
          }

        }

      })
    },
    setchart(data){

      let arrdata=[]
      for(let i=0;i<data.length;i++){
        arrdata.push({
          value: data[i].monitorSiteDegree, name: data[i].monitorSiteName
        })
      }
      let myChart =this.$echarts.init(document.getElementById('precav'));
      let option = {
        tooltip: {
          trigger: 'item'
        },
        color:this.colorList,

        series: [
          {
            name: '能耗占比',
            type: 'pie',

            radius: ['30%', '90%'],
            center: ['50%', '50%'],
            // itemStyle:{
            //
            // },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {

            },
            labelLine: {
              show: false
            },
            data: arrdata
          }
        ]
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    uploaddata(){
if(this.timetype=='1'){
  this.printdayexl()
}else if(this.timetype=='2'){
this.printmonthexl()
}
    },
    printdayexl(){
      let that = this;
      let param = {};
      param.url="/energy/exportDayEnergyReport";
      param.params={
        reportType:this.datatype,
        startDate:this.datastart,
        endDate:this.dataend,
      }
      axios({
        methods: 'get',
        url: this.baseUrl+param.url,
        params:param.params,
        responseType: 'blob'
      }).then((res)=>{

        const aLink = document.createElement("a");

        let blob = new Blob([res.data], {type: "application/vnd.ms-excel;charset=utf-8"})

        aLink.href = URL.createObjectURL(blob)

        aLink.download = '日能耗报表.xls'

        aLink.click()

        document.body.appendChild(aLink)



      })
    },
    printmonthexl(){
      let that = this;
      let param = {};
      param.url="/energy/exportMonthEnergyReport";
      param.params={
        reportType:this.datatype,
        startMonth:this.monthstart,
        endMonth:this.monthend,
      }
      axios({
        methods: 'get',
        url: this.baseUrl+param.url,
        params:param.params,
        responseType: 'blob'
      }).then((res)=>{

        const aLink = document.createElement("a");

        let blob = new Blob([res.data], {type: "application/vnd.ms-excel;charset=utf-8"})

        aLink.href = URL.createObjectURL(blob)

        aLink.download = '月能耗报表.xls'

        aLink.click()

        document.body.appendChild(aLink)



      })
    },
    choseurl(){
      this.isfir=true
    }
  },
  mounted() {
   this.getnowtime()
   this.searchdata()
   this.getpowdata()
   this.getchartdata()
  },
};
</script>

<style lang="less" scoped>
.personalCenter{

}
.pom-bar{
  background: #FFFFFF;
  border-radius: 0px 4px 4px 4px;
  height: 58px;
  padding:24px 0 0 36px;

  font-size: 14px;
  color: #7D879F;
  .active-bar{

    color: #252B3C;
  }
  .gray-line{
    margin: 0 6px;
  }
}
.report-btn{
  width: 100px;
  height: 32px;
  background: #2A62FF;
  border-radius: 4px;
  display: inline-block;
  float: right;
  color: #fff;
  text-align: center;
  line-height: 32px;
  position: relative;
  top: -10px;
  right: 20px;
  cursor: pointer;
}
.power-sum{
  background: #FFFFFF;
  border-radius: 0px 4px 4px 4px;
  margin-top: 14px;
}
.sec-blank{
  background: #FFFFFF;
  border-radius: 0px 4px 4px 4px;
  margin-top: 14px;
  height: calc(100% - 100px);
}
.time-select{
  float:right;
  position: relative;
  margin-right:40px;
  margin-top: 36px;

}
.cav-chart{

  width:100%;
  margin:0 40px;
  height:284px;
}
.item-title{
  height: 56px;
  border: 2px solid #F1F0F0;
  padding-left: 36px;
  line-height: 56px;
  color: #252B3C;
  font-size: 16px;
}
.risk-history{
  //width: 759px;
  //height: 420px;
  //background: #FFFFFF;
  //box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  //border-radius: 2px;
  //position: absolute;
  //top:calc(50% - 230px);
  //right:  calc(50% - 200px);
  z-index: 10;
  .risk-history-title{
    text-align: center;
    color: #252B3C;
    font-size: 16px;
    height: 64px;
    line-height: 64px;
  }
  .close-X{
    position: absolute;
    top: 23px;
    right: 23px;
    cursor: pointer;
  }
  .search-blank{
    padding:11px 36px 0 36px;
  }
  .search-btn{
    width: 56px;
    height: 28px;
    background: #2A62FF;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 28px;
    display:inline-block;
    margin: 0 12px;
    cursor: pointer;
  }
  .restart-btn{
    width: 56px;
    height: 28px;
    background: #fff;
    border-radius: 4px;
    color: #2A62FF;
    text-align: center;
    line-height: 28px;
    display:inline-block;
    border: 1px solid #2A62FF;
    cursor: pointer;
  }

}
.data-chose{
  width: 100%;
  height: 250px;
  padding: 6px 0 0 40px;
}
.date-select{
  margin-top: 16px;
  height: 70px;
}
.statin-btn{
  float: right;
  margin-right: 30px;
  .btn-item{
    display: inline-block;
    width: 80px;
    height: 40px;
    background: #2A62FF;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;

    cursor: pointer;
  }
  .btn-cancel{
    display: inline-block;
    width: 80px;
    height: 40px;
    background: #fff;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    color: #2A62FF;
    border: 1px solid #2A62FF;
    font-size: 14px;
    margin-left: 12px;
    cursor: pointer;
  }
}
.cir-fang{
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  margin-right: 10px;

}
.detiail-item{
  display:inline-block;
  vertical-align: top;
  width: 100%;
  height: 280px;

  .station-item{
    width: 100%;
    height: 280px;
    font-size: 14px;
    display: inline-block;
    vertical-align: top;
    .flex-item{
      display: inline-block;
      vertical-align: top;
      width: 400px;
      margin-top: 20px;
      margin-right: 10px;
      .item-name{
        display: inline-block;
        vertical-align: top;
        width:140px;
        border-right: 1px solid #ddd;
      }
      .item-percent{
        display: inline-block;
        vertical-align: top;
        width:80px;
        margin-left: 10px;
      }
      .item-num{
        display: inline-block;
        vertical-align: top;
        width: 120px;
        margin-left: 10px;
      }
    }

  }
}
.data-card{
  margin-top: 32px;
  position: relative;
  padding-left: 36px;
  padding-bottom: 36px;
  .btn-item{
    position: absolute;
    right: 40px;
    top: 20px;
    display: inline-block;
    width: 120px;
    height: 40px;
    background: #2A62FF;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    margin-left: 48px;
    cursor: pointer;

  }
}
.btn-item{

  display: inline-block;
  width: 60px;
  height: 40px;
  background: #2A62FF;
  border-radius: 4px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-left: 48px;
  cursor: pointer;

}
.card-item{
  width: 400px;
  display: inline-block;
  position: relative;
  vertical-align: top;
  height: 122px;
  background: #F5F8FD;
  color: #7D879F;
  font-size: 14px;
  margin-right: 20px;
  .card-left{
    width: 50%;
    display: inline-block;
    vertical-align: top;
    padding: 33px 0 0 30px;
    .blue-font{
      margin-top: 14px;
      color: #2A62FF;
      font-size: 20px;
    }
    .red-font{

      font-size: 12px;
      color: #D61E1E;
      margin-left: 8px;
    }
    .green-font{

      font-size: 12px;
      color: #008B61;
      margin-left: 8px;
    }
    .gray-font{
      margin-top: 14px;
      font-size: 20px;
    }
  }
  .infor-point{
    position: absolute;
    top: 32px;
    right: 20px;
    cursor: pointer;
  }
}
.warm-blank{
  width: 1400px;
  margin: 0 auto;
  height: 300px;
}
.item-group{
  display:inline-block;
  cursor: pointer;
  .item-btn{
    font-size: 14px;
    color: #7D879F;
    margin-right: 36px;
    display: inline-block;
    z-index: 100;
    vertical-align: top;
    .blue-blank{
      width: 100%;
      margin-top: 12px;
      height: 2px;

    }

  }
  .item-btn:nth-last-child(2){
    margin-right: 10px;
  }
  .active-btn{
    color: #2A62FF;
    position: relative;
    .blue-blank{
      width: 100%;
      margin-top: 12px;
      height: 2px;
      background-color:  #2A62FF;

    }
  }
  .gray-line{
    height: 2px;
    border: 1px solid #F1F0F0;
    position: relative;
    top: -2px;
    z-index: 1;
  }
}
.cav-select{
padding: 20px 0 0 36px;
  margin-bottom: 20px;
}
.all-cav{
  padding: 20px 0 0 36px;
}
.cir-cav{
  display: inline-block;
  width: 300px;
  height: 300px;
  vertical-align: top;
  margin-right: 80px;
}
.cir-detail{
  display: inline-block;
  width: 840px;
  vertical-align: top;
}
.nodata-table{
  width: 100%;
  height:320px;
  line-height: 320px;
  text-align: center;
}
.fir-blank{
  padding-bottom: 20px;
}
</style>

<style lang="less">

</style>
